
import { Component, Prop } from 'vue-property-decorator';
import StackedForm from '../../../mixins/StackedForm';
import { mixins } from 'vue-class-component';
import VFormBuilder from '../../shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';

@Component({
  components: { VFormBuilder },
})
export default class ImageForm extends mixins(StackedForm) {
  @Prop({ type: Boolean, required: true }) public editing!: boolean;

  get items() {
    return [
      {
        name: 'assets',
        type: InputType.DragAndDropImage,
        label: 'article.form.image',
        default: null,
        accept: 'image/*',
        hint: this.$t('common.imageMaxSizeNotice', { max: 10 }),
        max: 10,
      },
      {
        name: 'banner',
        type: InputType.DragAndDropImage,
        label: 'article.form.banner',
        default: null,
        accept: 'image/*',
        hint: this.$t('common.imageMaxSizeNotice', { max: 10 }),
        max: 10,
      },
      {
        name: 'bannerVideo',
        type: InputType.DragAndDropVideo,
        label: 'article.form.bannerVideo',
        default: null,
        accept: 'video/mp4,video/mov',
        visible: this.editing,
      },
      {
        name: 'icon',
        type: InputType.DragAndDropImage,
        label: 'article.form.icon',
        default: null,
        accept: 'image/*',
        hint: this.$t('common.imageMaxSizeNotice', { max: 10 }),
        max: 10,
      },
    ];
  }

  public getData() {
    const data: any = { ...this.$refs.form.form };
    const filesToRemove: string[] = this.$refs.form.getFilesToRemove();

    if (data.assets === null) {
      delete data.assets;
    }
    if (data.banner === null) {
      delete data.banner;
    }
    if (data.icon === null) {
      delete data.icon;
    }
    if (data.bannerVideo === null) {
      delete data.bannerVideo;
    }

    if (this.initialValues) {
      // @ts-ignore
      if (
        // @ts-ignore
        this.initialValues.assets &&
        // @ts-ignore
        this.initialValues.assets.thumb &&
        // @ts-ignore
        this.initialValues.assets.thumb.length > 0 &&
        filesToRemove.indexOf('assets') > -1
      ) {
        data.assets = {
          thumb: '',
          medium: '',
          large: '',
          original: '',
        };
      }
      // @ts-ignore
      if (
        // @ts-ignore
        this.initialValues.icon &&
        // @ts-ignore
        this.initialValues.icon.thumb &&
        // @ts-ignore
        this.initialValues.icon.thumb.length > 0 &&
        filesToRemove.indexOf('icon') > -1
      ) {
        data.icon = {
          thumb: '',
          medium: '',
          large: '',
          original: '',
        };
      }

      // @ts-ignore
      if (
        // @ts-ignore
        this.initialValues.banner &&
        // @ts-ignore
        this.initialValues.banner.thumb &&
        // @ts-ignore
        this.initialValues.banner.thumb.length > 0 &&
        filesToRemove.indexOf('banner') > -1
      ) {
        data.banner = {
          thumb: '',
          medium: '',
          large: '',
          original: '',
        };
      }

      // @ts-ignore
      if (
        // @ts-ignore
        this.initialValues.bannerVideo &&
        filesToRemove.indexOf('bannerVideo') > -1
      ) {
        data.bannerVideo = null;
      }
    }

    return { ...data };
  }
}
